import type * as React from 'react'

import {
  XIcon,
  IconButton,
  Paragraph,
  UnstyledButton,
} from '@buffer-mono/popcorn'

import { selectContentGenerationStatus } from '~publish/legacy/ai/state/slice'
import { useAppSelector } from '~publish/legacy/store'

import styles from './Prompt.module.css'

import type { JSX } from 'react'

/**
 *
 */
function Prompt({
  expanded,
  lines,
  prompt,
  withBackground,
  onToggle,
  onClear,
}: {
  expanded: boolean
  prompt: string
  lines?: number
  withBackground?: boolean
  onToggle: () => void
  onClear: () => void
}): JSX.Element {
  const { contentGenerationInProgress } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )

  const onClearClick = (event: React.MouseEvent): void => {
    event.preventDefault()
    event.stopPropagation()
    onClear()
  }

  return (
    <div
      className={`${styles.wrapper} ${expanded ? styles.expanded : ''} ${
        withBackground ? styles.withBackground : ''
      } ${contentGenerationInProgress ? styles.disabled : ''}`}
    >
      <UnstyledButton
        className={styles.promptButton}
        disabled={contentGenerationInProgress}
        onClick={onToggle}
      >
        <Paragraph
          className={styles.prompt}
          data-testid="ai-assistant-prompt"
          style={{ WebkitLineClamp: lines || 1 }}
        >
          {prompt}
        </Paragraph>
      </UnstyledButton>
      {!contentGenerationInProgress && (
        <IconButton
          onClick={onClearClick}
          label="Clear prompt"
          size="small"
          variant="tertiary"
          data-testid="ai-assistant-clear-prompt-button"
          className={styles.clearButton}
        >
          <XIcon />
        </IconButton>
      )}
    </div>
  )
}

export { Prompt }
